/**
 * Narrow entry point for the Turso actor-sync connection only.
 *
 * The main barrel (`+.ts`) re-exports `openSqliteDatabase`, which has a
 * top-level expo-sqlite import. On web that drags expo-sqlite's
 * `@sqlite.org/sqlite-wasm` worker (which Metro can't resolve through the
 * `new URL("sqlite3-worker1.mjs", import.meta.url)` worker info) into any
 * module that imports the barrel. The web actor connection needs ONLY the Turso
 * sync opener (sync-wasm), so it imports through this subpath to avoid pulling
 * the expo-sqlite engine into the web graph.
 */
export { openActorTursoSyncConnection } from "#open-actor-turso-sync-connection";
export type {
  ActorTursoSyncConnection,
  ActorTursoSyncOptions,
} from "#open-actor-turso-sync-connection-types";
// Web-only: the signed-out (guest) connection runs the SAME sync-wasm engine with
// no url, so it belongs on this subpath for the same reason — it must not drag the
// expo-sqlite engine into the web graph.
export { openGuestTursoConnection, type GuestTursoConnection } from "#open-guest-turso-connection";
// Web-only: the multi-tab leader proxy for the guest database. Imports only the
// leader-resource CLIENT half (the host half lives on its own subpath and is
// pulled in solely by the `bun build`-produced worker asset), so this adds no
// worker/wasm code to the app bundle.
export {
  openProxiedActorTursoConnection,
  openProxiedGuestTursoConnection,
  type ProxiedTursoConnection,
  type ProxiedTursoSyncOptions,
} from "#open-proxied-turso-connection";
export { wipeTursoDatabaseFiles } from "#wipe-turso-database-files";
export { checkTursoWebSupport, type TursoWebSupport } from "#check-turso-web-support";
